export class localStorageService {
  static getItem(key: string): string | null {
    return localStorage.getItem(key)
  }

  static setItem(key: string, value: string): void {
    if (value === null || value === undefined) {
      return
    }
    localStorage.setItem(key, value)
    window.dispatchEvent(new Event('local-storage'))
  }

  static removeItem(key: string): void {
    localStorage.removeItem(key)
  }

  static clear(): void {
    localStorage.clear()
    window.dispatchEvent(new Event('local-storage'))
  }
}
